import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetArticleListFailed, EGetArticleListActionType } from './types';

export const getArticleListFailed: () => TGetArticleListFailed = actionGenerator<EGetArticleListActionType.Failed>(
  EGetArticleListActionType.Failed,
);
